import { Segment, Form, FormGroup, FormField, Label, Button, Icon, Image } from "semantic-ui-react";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { STYLES, ICONS } from "./sequence/MeForm";
import { PickedState } from "./MeFormType";
import { formatISOtoBEDateTime } from "react-lib/utils/dateUtils";
import { formatCredit, creditAmount } from "./MeFormUtils";
import { useMemo } from "react";
import { BroadcastMode } from "./MeCastType";

type Props = {
  // config
  mode: BroadcastMode;
  // func & callback
  onOpenBuyCredit: () => void;
  // data
  isAmount: boolean;
  creditUsage?: string;
} & Pick<PickedState, "BillingCreditWallet">;

const CreditInfoBox = ({ isAmount, creditUsage, BillingCreditWallet, mode, onOpenBuyCredit }: Props) => {
  const credit = creditUsage || "0.00";

  return (
    <Segment style={{ border: "solid 1px var(--primary-theme-color)", width: "100%" }}>
      <Form>
        <FormGroup inline>
          <FormField width={7}>
            <label>This broadcast will use</label>
          </FormField>
          <FormField width={5}>
            <Label
              style={{
                ...STYLES.primaryThemeLabel,
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
              content={formatCredit(credit)}
            />
          </FormField>
          <FormField width={4}>
            <label>credits in total</label>
          </FormField>
        </FormGroup>

        <FormGroup inline style={{ marginBottom: 0 }}>
          <FormField
            width={7}
            style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
          >
            <label>Your credit balance</label>
            <label style={{ fontWeight: "normal", color: "grey", fontSize: 10 }}>
              {formatISOtoBEDateTime(BillingCreditWallet.balance_updated_at).dateTimeShortBracket}
            </label>
          </FormField>
          <FormField width={5}>
            <Label
              style={{
                ...STYLES.primaryThemeLabel,
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                color: !isAmount ? "red" : "black",
              }}
              content={formatCredit(BillingCreditWallet.balance)}
            />
          </FormField>
          <FormField width={4}>
            <ButtonLoadCheck
              size="mini"
              style={STYLES.primaryThemeBtn}
              fluid
              title={
                <div style={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                  <label>BUY</label>
                  <Icon name="shopping cart" />
                </div>
              }
              onClick={onOpenBuyCredit}
              // config
              disabled={mode === "VIEW"}
            />
          </FormField>
        </FormGroup>

        {!isAmount && (
          <FormGroup style={{ margin: 0 }}>
            <FormField width={7}>
              <div></div>
            </FormField>
            <FormField width={5} style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ fontWeight: "normal", color: "red", fontSize: 11 }}>
                <Icon name="warning" />
                <label>
                  Insurficient Credit
                </label>
              </div>  
            </FormField>
            <FormField width={4}>

            </FormField>
          </FormGroup>
        )}
      </Form>
    </Segment>
  );
};
export default CreditInfoBox;
